import { createAuth0 } from '@auth0/auth0-vue';
import mockAuth0Plugin from './mockAuth0Plugin';

const extractLanguageFromUrl = (url: string): string => {
  const match = new RegExp(/^https?:\/\/[^/]+\/([^/]+)/).exec(url);
  return match ? match[1] : 'en';
};

const auth0 = createAuth0(
  {
    domain: import.meta.env.VUE_APP_AUTH_DOMAIN,
    clientId: import.meta.env.VUE_APP_AUTH_CLIENT_ID,
    authorizationParams: {
      audience: import.meta.env.VUE_APP_AUTH_AUDIENCE,
      redirect_uri: `${window.location.origin}/${extractLanguageFromUrl(window.location.href)}/ubm/login-callback`,
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: import.meta.env.VUE_APP_AUTH_USE_FALLBACK !== 'false',
  },
  {
    skipRedirectCallback: true,
  },
);

export default import.meta.env.VUE_APP_MOCK_AUTH === 'ui-tests' ? mockAuth0Plugin : auth0;
